import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Box } from "@mui/material";
import { addDoc, collection, doc } from "firebase/firestore";
import { db, storage } from "../../../FirebaseConfig";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { updateDataByID } from "../../../Utils/firebaseServices";
import LoadingCircular from "../../../loader/LoadingCircular";

const AddDetailsInSubCategory = ({ open, onClose, componentData }) => {
  const [formData, setFormData] = useState({
    title: "",
    desc: "",
    extra_desc: "",
    isActive: false,
    tags: [""],
    items: [{ imageUrl: null, tag: "" }],
    l_s_c_id: "",
  });


  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false); 
  useEffect(() => {
    if (open) {
      setFormData({
        title: "",
        desc: "",
        extra_desc: "",
        isActive: false,
        tags: [""],
        items: [{ imageUrl: null, tag: "" }],
        l_s_c_id: "",
      });
      setErrors({})
    }
  }, [open]);

  const handleChange = (e, index = null) => {
    const { name, value, type, checked, files } = e.target;

    if (name === "imageUrl") {
      const updateditems = [...formData.items];
      updateditems[index] = { ...updateditems[index], imageUrl: files[0] };
      setFormData({
        ...formData,
        items: updateditems,
      });
    } else if (name.startsWith("tag")) {
      if (index !== null) {
        const updateditems = [...formData.items];
        updateditems[index] = { ...updateditems[index], tag: value };
        setFormData({
          ...formData,
          items: updateditems,
        });
      } else {
        const updatedTags = [...formData.tags];
        const tagIndex = parseInt(name.replace("tag", ""), 10);
        updatedTags[tagIndex] = value;
        setFormData({
          ...formData,
          tags: updatedTags,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };




  const validate =()=>{
    let errors_template ={}
    errors_template.title = formData.title ?"":"This field is required";
    errors_template.desc = formData.desc ? "": "This field is required";
    errors_template.extra_desc = formData.extra_desc?"":"This field is required";
    // errors_template.tags = formData.tags.some(tag => tag.trim() === "") ? "Tags cannot be empty" : "";
    // errors_template.items = formData.items.some(item => !item.imageUrl || item.tag.trim() === "") ? "All items must have an image and a tag" : "";
    setErrors(errors_template);
    return Object.values(errors_template).every(x => x === "");

  }

  const handleAddTag = () => {
    setFormData({
      ...formData,
      tags: [...formData.tags, ""],
    });
  };

  const handleAddimageUrlTag = () => {
    setFormData({
      ...formData,
      items: [...formData.items, { imageUrl: null, tag: "" }],
    });
  };

 
  const handleSubmit = async () => {
    if (!validate()) return;

    setLoading(true); // Start loading

    const updatedFormData = { ...formData };
    updatedFormData.tags = updatedFormData.tags.filter(
      (tag) => tag.trim() !== ""
    );
    updatedFormData.items = updatedFormData.items.filter(
      (pt) => pt.imageUrl !== null
    );

    const newDocRef = doc(
      collection(db, "library_sidebar_category_details_collection")
    );

    updatedFormData.l_s_c_id = newDocRef.id;

    try {
      const uploadPromises = updatedFormData.items?.map(async (pt) => {
        const storageRef = ref(
          storage,
          `library_sidebar_category_details_collection/${formData.title}_${pt.tag}`
        );
        const uploadTask = uploadBytesResumable(storageRef, pt.imageUrl);
        const downloadURL = await new Promise((resolve, reject) => {
          uploadTask.on("state_changed", null, reject, () => {
            getDownloadURL(uploadTask.snapshot.ref).then(resolve).catch(reject);
          });
        });
        return { ...pt, imageUrl: downloadURL };
      });

      updatedFormData.items = await Promise.all(uploadPromises);

      await addDocToFirestore(updatedFormData);
    } catch (error) {
      console.error("Error uploading data:", error);
    } finally {
      setLoading(false); 
    }
  };

  const addDocToFirestore = async (updatedFormData) => {
    try {
      const docRef = await addDoc(
        collection(db, "library_sidebar_category_details_collection"),
        updatedFormData
      );
      console.log("Document written with ID:", docRef.id);
      if (docRef.id) {
        handleSwitchChange(docRef.id);
      }
      onClose();
      setFormData({
        title: "",
        desc: "",
        extra_desc: "",
        isActive: false,
        tags: [""],
        items: [{ imageUrl: null, tag: "" }],
        l_s_c_id: "",
      });
    } catch (error) {
      console.error("Error adding document:", error);
    }
  };

  const getParseData = (item) => {
    if (item) {
      return JSON.parse(item);
    } else {
      return "";
    }
  };
  function updateItemByIndex({ id }) {
    let all_items_of_cat = componentData?.category?.items;
    let item = getParseData(all_items_of_cat[componentData?.index])
    item?.l_s_c_d_id?.push(id)
    item.isDetailAvailable = true;
    all_items_of_cat.splice(componentData?.index, 1, JSON.stringify(item));
    let new_data_obj = {
      ...componentData?.category,
      items:all_items_of_cat
    }
    return new_data_obj;
  }

  const handleSwitchChange = async (newId) => {

    let data_obj = updateItemByIndex({ id:newId });

    const res = await updateDataByID(
      componentData?.category?.id,
      data_obj,
      "library_sidebar_categories_collection",
      (res)=>console.log("res",res)
    );
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.1)" },
      }}
      sx={{
        "& .MuiPaper-root": {
          boxShadow: "none",
        },
      }}
    >
      {loading?(
        <LoadingCircular/>
      ):(
        <>
        <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          name="title"
          label="Title"
          type="text"
          fullWidth
          variant="outlined"
          value={formData.title}
          error={!!errors.title}
          helperText={errors.title}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="desc"
          label="Description"
          type="text"
          fullWidth
          variant="outlined"
          value={formData.desc}
          error={!!errors.desc}
          helperText={errors.desc}
          onChange={handleChange}
          multiline
          rows={2}
        />
        <TextField
          margin="dense"
          name="extra_desc"
          label="Extra Description"
          type="text"
          fullWidth
          variant="outlined"
          value={formData.extra_desc}
          error={!!errors.extra_desc}
          helperText={errors.extra_desc}
          onChange={handleChange}
          multiline
          rows={3}
        />
        <Box marginY={2}>
          <FormControlLabel
            control={
              <Checkbox
                name="isActive"
                checked={formData.isActive}
                onChange={handleChange}
              />
            }
            label="Is Show Example"
          />
        </Box>

        {/* Tags Section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "16px",
          }}
        >
          {formData.tags?.map((tag, index) => (
            <Box key={index} marginBottom={1}>
              <TextField
                margin="dense"
                name={`tag${index}`}
                label={`Tag ${index + 1}`}
                type="text"
                variant="outlined"
                value={tag}
                onChange={handleChange}
                error={!!errors.tags}
                helperText={errors.tags}
              />
            </Box>
          ))}
          <Button onClick={handleAddTag} variant="contained" color="primary">
            Add
          </Button>
        </div>

        {formData.items?.map((pt, index) => (
          <Box
            key={index}
            marginBottom={2}
            display="flex"
            alignItems="center"
            gap={2}
          >
           
            <TextField
              margin="dense"
              name={`tag${index}`}
              label={`Tag for imageUrl ${index + 1}`}
              type="text"
              variant="outlined"
              value={pt.tag}
              onChange={(e) => handleChange(e, index)}
              style={{ flex: 1 }}
              error={!!errors.items}
              helperText={errors.items}
            />
             <input
              type="file"
              name="imageUrl"
              onChange={(e) => handleChange(e, index)}
              style={{ flex: 1 }}
              error={!!errors.items}
            />
          </Box>
        ))}

        <Button
          onClick={handleAddimageUrlTag}
          variant="contained"
          color="primary"
          style={{ marginTop: "16px" }}
        >
          Add Another imageUrl and Tag
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" size="large"
         disabled={loading} >
          Submit
        </Button>
      </DialogActions></>
      )}
      
    </Dialog>
  );
};

export default AddDetailsInSubCategory;
